/**
 * @generated SignedSource<<62a8af266f10c4049472dbb5ec8ea861>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionInfo_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_user" | "PdpSharedAuctionActionCompletePurchase_user" | "PdpSharedAuctionSecondChanceOffer_user">;
  readonly " $fragmentType": "PdpSharedAuctionInfo_user";
};
export type PdpSharedAuctionInfo_user$key = {
  readonly " $data"?: PdpSharedAuctionInfo_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionInfo_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionInfo_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBinAndBid_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionCompletePurchase_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionSecondChanceOffer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6ffe2b761be195b7c38c16a246672579";

export default node;
